// Fatia S1: encerra a sessão e volta para o site.
import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { api } from '../../lib/api'
import { Loading } from '../../ui'

export default function Logout() {
  const navigate = useNavigate()
  const qc = useQueryClient()
  const started = useRef(false)
  useEffect(() => {
    if (started.current) return
    started.current = true
    api.post('/auth/logout').catch(() => {}).finally(() => {
      qc.clear()
      qc.setQueryData(['me'], null)
      navigate('/', { replace: true })
    })
  }, [navigate, qc])
  return <div className="auth-wrap"><div className="auth-card"><p className="muted" style={{ textAlign: 'center' }}>Saindo…</p><Loading lines={1} /></div></div>
}
